module.exports = __webpack_public_path__ + "static/Imagem_2-a871a1f443cb8319bd5de4faa5f0e546.jpeg";